







































import {Component, Vue , Prop} from "vue-property-decorator";
import dataObj from '@/core/cosUploadFile.js';

@Component({})
export default class InvestorItem extends Vue{
  @Prop({
    type:Object,
    default:()=>{}
  })
  investorInfo: any;

  formatDate(timestamp:any) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  changeLogo(logo:any) {
    let arr = dataObj.autograph.addAutograph(logo)
    return arr;
  }

  getCaseInfo(){

  }

  private onDetail(){

  }

  private onConsult(){

  }
}
